module.exports = __webpack_public_path__ + "img/oldman_landing_3.81d6c04a.png";